import { AdvancedSearchTypes } from 'app/types-shared';
import { AdvancedSearchField, FilterOption, Filter, ReportData, FilterDomainNode } from 'app/components/filters/types';
import { FilterOptionType } from 'app/area/filters/types';

export const ACTION = {
  REQUEST_FILTER_DOMAINS: 'FILTERS:REQUEST_FILTER_DOMAINS',
  RECEIVE_FILTER_DOMAINS: 'FILTERS:RECEIVE_FILTER_DOMAINS',
  UPDATE_FILTERS: 'FILTERS:UPDATE_FILTERS',
  RECEIVE_ADVANCED_SEARCH_TYPES: 'FILTERS:RECEIVE_ADVANCED_SEARCH_TYPES',
  RECEIVE_ADVANCED_SEARCH_OPTIONS: 'FILTERS:RECEIVE_ADVANCED_SEARCH_OPTIONS',
  RECEIVE_ORIGINAL_DOMAIN_NODES_OPTIONS: 'FILTERS:RECEIVE_ORIGINAL_DOMAIN_NODES_OPTIONS',
  RECEIVE_REPLACE_DOMAIN_NODES_OPTIONS: 'FILTERS:RECEIVE_REPLACE_DOMAIN_NODES_OPTIONS',
  RECEIVE_REMOVE_DOMAIN_NODES_OPTIONS: 'FILTERS:RECEIVE_REMOVE_DOMAIN_NODES_OPTIONS',
  SET_FILTER_OPTION: 'FILTERS:SET_FILTER_OPTION',
  SET_FILTER_OPEN_STATE: 'FILTERS:SET_FILTER_OPEN_STATE',
  CLEAR_FILTER_OPTIONS: 'FILTERS:CLEAR_FILTER_OPTIONS',
  CLEAR_ALL_FILTER_OPTIONS: 'FILTERS:CLEAR_ALL_FILTER_OPTIONS',
  CLEAR_ALL: 'FILTERS:CLEAR_ALL',

  ADD_INSTANCE: 'FILTERS:ADD_INSTANCE',
  CLEAR_INSTANCE: 'FILTERS:CLEAR_INSTANCE'
};

export class RequestFilterDomains {
  public type: string = ACTION.REQUEST_FILTER_DOMAINS;
  constructor(public instanceKey: string) {}
}

export class ReceiveFilterDomains {
  public type: string = ACTION.RECEIVE_FILTER_DOMAINS;
  constructor(public instanceKey: string, public filters: FilterDomainNode[], public report?: ReportData) {}
}

export class UpdateFilters {
  public type: string = ACTION.UPDATE_FILTERS;
  constructor(public instanceKey: string, public data: Filter[]) {}
}

export class ReceiveAdvancedSearchTypes {
  public type: string = ACTION.RECEIVE_ADVANCED_SEARCH_TYPES;
  constructor(public instanceKey: string, public data: AdvancedSearchTypes[]) {}
}

export class ReceiveAdvancedSearchOptions {
  public type: string = ACTION.RECEIVE_ADVANCED_SEARCH_OPTIONS;
  constructor(public instanceKey: string, public options: AdvancedSearchField[]) {}
}

export class ReceiveOriginalDomainNodesOptions {
  public type: string = ACTION.RECEIVE_ORIGINAL_DOMAIN_NODES_OPTIONS;
  constructor(public instanceKey: string, public options: AdvancedSearchField[]) {}
}

export class ReceiveReplaceDomainNodesOptions {
  public type: string = ACTION.RECEIVE_REPLACE_DOMAIN_NODES_OPTIONS;
  constructor(public instanceKey: string, public options: AdvancedSearchField[]) {}
}

export class ReceiveRemoveDomainNodesOptions {
  public type: string = ACTION.RECEIVE_REMOVE_DOMAIN_NODES_OPTIONS;
  constructor(public instanceKey: string, public options: AdvancedSearchField[]) {}
}

export class SetFilterOpenState {
  public type: string = ACTION.SET_FILTER_OPEN_STATE;
  constructor(public instanceKey: string, public id:string, public value:boolean) {}
}

export class SetFilterOption {
  public type: string = ACTION.SET_FILTER_OPTION;
  constructor(public instanceKey: string, public option: FilterOption, public filterOptionType: FilterOptionType) {}
}

export class ClearFilterOptions {
  public type: string = ACTION.CLEAR_FILTER_OPTIONS;
  constructor(public instanceKey: string, public id: string) {}
}

export class ClearAllFilterOptions {
  public type: string = ACTION.CLEAR_ALL_FILTER_OPTIONS;
  constructor(public instanceKey: string) {}
}

export class ClearAll {
  public type: string = ACTION.CLEAR_ALL;
  constructor(public instanceKey: string) {}
}

export class AddInstance {
  public type: string = ACTION.ADD_INSTANCE;
  constructor(public instanceKey: string) {}
}

export class ClearInstance {
  public type: string = ACTION.CLEAR_INSTANCE;
  constructor(public instanceKey: string) {}
}
